import script from "./AppChatbot.vue?vue&type=script&setup=true&lang=js"
export * from "./AppChatbot.vue?vue&type=script&setup=true&lang=js"

import "./AppChatbot.vue?vue&type=style&index=0&id=3faaec9f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3faaec9f"]])

export default __exports__